<template>
  <div>
    <card>
        <h3 style="color:#00467f">Dati Soggetto</h3>
        <!-- <hr> -->
        <form>
            <div class="form-row">
                <!-- <div class="form-group col-md-1"> -->
                    <label style="color:#00467f;display: flex;word-wrap: break-word;vertical-align: middle;" for="soggetto_estero"><input type="checkbox" v-model="soggetto_estero" id="soggetto_estero" style="margin-left:5px;" class="form-control">Soggetto Estero (impostare questo flag solo per la gestione di soggetti senza codice fiscale italiano)</label>
                <!-- </div> -->
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="codice_fiscale">Codice Fiscale<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="codice_fiscale" placeholder="codice_fiscale">
                </div>
                <div class="form-group col-md-4">
                    <label for="cognome">Cognome<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="cognome" placeholder="cognome">
                </div>
                <div class="form-group col-md-4">
                    <label for="nome">Nome<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="nome" placeholder="Nome">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="data_nascita">Data di nascita<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_nascita" placeholder="data_nascita">
                </div>
                <div class="form-group col-md-4">
                    <label for="comune_nascita">Comune di nascita<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="comune_nascita" placeholder="comune_nascita">
                </div>
                <div class="form-group col-md-4">
                    <label for="provincia">Provincia di nascita<span style="color:#ff0000">*</span></label>
                    <!-- <input type="text" class="form-control" v-model="provincia" placeholder="provincia"> -->
                    <select v-model="provincia" class="form-control">
                        <option disabled value="">Seleziona una provincia</option>
                        <option v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value">{{val.text}}</option>
                    </select>
                    
                </div>
            </div>
            <!-- -->
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="sesso">Sesso<span style="color:#ff0000">*</span></label>
                    <select v-model="sesso" class="form-control">
                        <option>M</option>
                        <option>F</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <label for="stato">Stato<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="stato" placeholder="stato">
                </div>
                <div class="form-group col-md-4">
                    <label for="tipo">Tipo<span style="color:#ff0000">*</span></label>
                    <select v-model="tipo" class="form-control">
                        <option value="titolare ditta individuale">Titolare ditta individuale</option>
                        <option value="rappresentante legale">Rappresenante legale</option>
                        <option value="amministratore delegato">Amministratore delegato</option>
                        <option value="delegato a operare">Delegato a operare</option>
                        <option value="socio">Socio</option>
                        <option value="esecutore">Esecutore</option>
                    </select>
                </div>
            </div>
            <h3 style="margin-top:20px;color:#00467f">Residenza</h3>
            <!-- <hr> -->
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="indirizzo_residenza">Indirizzo<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="indirizzo_residenza" placeholder="indirizzo_residenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="comune_residenza">Comune<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="comune_residenza" placeholder="comune_residenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="cap_residenza">CAP<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="cap_residenza" placeholder="cap_residenza">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="provincia_residenza">Provincia<span style="color:#ff0000">*</span></label>
                    <!-- <input type="text" class="form-control" v-model="provincia_residenza" placeholder="provincia_residenza"> -->
                    <select v-model="provincia_residenza" class="form-control">
                        <option disabled value="">Seleziona una provincia</option>
                        <option v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value">{{val.text}}</option>
                    </select>
                </div>
                <div class="form-group col-md-6">
                    <label for="stato_residenza">Stato<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="stato_residenza" placeholder="stato_residenza">
                </div>
            </div>
        
            <!-- <h3 style="margin-top:20px;color:#00467f">Identificazione<span style="color:#ff0000">*</span></h3>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="tipo_identificazione">Tipo identificazione</label>
                    <select v-model="tipo_identificazione" class="form-control">
                        <option value="Direttamente">Direttamente</option>
                        <option value="tramite atti">Tramite atti</option>
                        <option value="dic consolare">Dic. consolare</option>
                        <option value="altro profess">Altro profess.</option>
                        <option value="interm. abilitati">Interm. Abilitati</option>
                        <option value="altre modalità">Altre modalità</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <label for="data">Data<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data">
                </div>
                <div class="form-group col-md-4">
                    <label for="tipo_documento">Tipo Documento<span style="color:#ff0000">*</span></label>
                    <select v-model="tipo_documento" class="form-control">
                        <option value="carta identita">Carta d'identità</option>
                        <option value="patente">Patente</option>
                        <option value="passaporto">Passaporto</option>
                        <option value="porto d'armi">Porto d'armi</option>
                        <option value="tess. postale">Tess. postale</option>
                        <option value="altro">Altro</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="numero_documento">Numero Documento<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="numero_documento" placeholder="numero_documento">
                </div>
                <div class="form-group col-md-4">
                    <label for="data_scadenza">Data Scadenza<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_scadenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="data_rilascio">Data Rilascio<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_rilascio">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="autorita_localita_rilascio">Autorità e località del rilascio<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="autorita_localita_rilascio">
                </div>
                <div class="form-group col-md-6">
                    <label for="tipo_documento">Dati acquisiti e verificati tramite<span style="color:#ff0000">*</span></label>
                    <select v-model="dati_acquisiti" class="form-control">
                        <option value="dichiarazione antiriciclaggio">Dichiarazione antiriciclaggio resa dal cliente x art. 22 D.Lgs 231/2007</option>
                        <option value="estratti pubblici registri">Estratti pubblici registri</option>
                        <option value="estratti elenchi">Estratti da elenchi, atti, documenti conoscibili da chiunque</option>
                    </select>
                </div>
            </div> -->
            
            <h3 style="margin-top:10px">Dati Antiriciclaggio</h3>
            <div class="form-row justify-content-center" style="margin-top:10px">
                <!--  <input type="checkbox" class="form-control" v-model="autorizzazione_emissione" style="margin-top:20px"><span class="slider round"></span>-->
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="titolare_effettivo" class="form-control">Titolare Effettivo</label>
                </div>
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="pep"  class="form-control">PEP (Persona Politicamente Esposta)</label>
                </div>
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="rappresentante_principale" class="form-control">Rappresentante Principale</label>
                </div>
                <div class="col-md-3">
                    <label class="float-left" style="margin-left:100px"><input type="checkbox" v-model="non_in_carica" class="form-control">Non in carica</label>
                </div>
            </div>
            <div class="form-row justify-content-center" style="margin-top:10px">
                <div class="col-md">
                     <label>Titolare effettivo dal</label>
                     <input type="date" class="form-control" v-model="titolare_effettivo_dal">
                </div>
                <div class="col-md">
                     <label>Titolare effettivo al</label>
                     <input type="date" class="form-control" v-model="titolare_effettivo_al">
                </div>
            </div>

            <div class="form-row" v-if="idSoggetto != null">
                <div class="form-group">
                    <h3 for="file" style="margin-bottom:20px">Carica documento personale<span style="color:#ff0000">*</span></h3>
                    <button class="btn" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()" accept=".jpg,.jpeg,.png,.pdf"></button>
                </div>
            </div>
        </form>
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <button v-if="idSoggetto == null" class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva Soggetto</button>
        <button v-if="idSoggetto != null" class="btn float-right" type="button" v-on:click="checkFileUpload()" style="margin-top: 10px;background:#00467f">Salva Documento</button>
       <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link>
        <!--  MODAL CARICARE FILE -->
        <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal>
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';

export default {
    components: {
        Card
    },

    data() {
        return {
            // DATI SOGGETTI
            codice_fiscale: null,
            soggetto_estero: false,
            cognome: null,
            nome: null,
            data_nascita: null,
            comune_nascita: null,
            provincia: null,
            listaProvince: [
               { value: "AG", text: "AG	Agrigento"}, { value: "AL", text: "AL Alessandria"}, 
               { value: "AN", text: "AN	Ancona"}, { value: "AO", text: "AO	Aosta"}, {value: "AQ", text: "AQ L'Aquila"}, 
               { value: "AR", text: "AR Arezzo"}, { value: "AP", text: "AP	Ascoli-Piceno"}, {value: "AT", text: "AT Asti"}, 
               { value: "BA", text: "BA	Bari"}, { value: "BT", text: "BT Barletta-Andria-Trani"}, {value: "BL", text: "BL Belluno"}, 
               { value: "BN", text: "BN Benevento"}, { value: "BG", text: "BG Bergamo"}, {value: "BI", text: "BI Biella"}, 
               { value: "BO", text: "BO	Bologna"}, { value: "BZ", text: "BZ Bolzano"}, {value: "BS", text: "BS Brescia"}, 
               { value: "BR", text: "BR Brindisi"}, { value: "CA", text: "CA Cagliari"}, {value: "CL", text: "CL Caltanissetta"}, 
               { value: "CB", text: "CB	Campobasso"}, { value: "CI", text: "CI Carbonia Iglesias"}, {value: "CE", text: "CE Caserta"}, 
               { value: "CT", text: "CT	Catania"}, { value: "CZ", text: "CZ Catanzaro"}, {value: "CH", text: "CH Chieti"}, 
               { value: "CO", text: "CO Como"}, { value: "CS", text: "CS Cosenza"}, {value: "CR", text: "CR	Cremona"}, 
               { value: "KR", text: "KR Crotone"}, { value: "CN", text: "CN	Cuneo"}, {value: "EN", text: "EN Enna"}, 
               { value: "FM", text: "FM	Fermo"}, { value: "FE", text: "FE Ferrara"}, {value: "FI", text: "FI Firenze"},
                { value: "FG", text: "FG Foggia"}, { value: "FC", text: "FC Forli-Cesena"}, {value: "FR", text: "FR Frosinone"}, 
               { value: "GE", text: "GE	Genova"}, { value: "GO", text: "GO Gorizia"}, {value: "GR", text: "GR Grosseto"}, 
               { value: "IM", text: "IM	Imperia"}, { value: "IS", text: "IS Isernia"}, {value: "SP", text: "SP La-Spezia"},
               { value: "LT", text: "LT	Latina"}, { value: "LE", text: "LE Lecce"}, {value: "LC", text: "LC Lecco"}, 
               { value: "LI", text: "LI	Livorno"}, { value: "LO", text: "LO	Lodi"}, {value: "LU", text: "LU	Lucca"}, 
               { value: "MC", text: "MC	Macerata"}, { value: "MN", text: "MN Mantova"}, {value: "MS", text: "MS	Massa-Carrara"}, 
               { value: "MT", text: "MT	Matera"}, { value: "VS", text: " VS Medio Campidano"}, {value: "ME", text: "ME Messina"}, 
               { value: "MI", text: "MI	Milano"}, { value: "MO", text: "MO Modena"}, {value: "MB", text: "MB Monza-Brianza"}, 
               { value: "NA", text: "NA	Napoli"}, { value: "NO", text: " NO	Novara"}, {value: "NU", text: "NU Nuoro"}, 
               { value: "OG", text: "OG	Ogliastra"}, { value: "OT", text: "OT Olbia Tempio"}, {value: "OR", text: "OR Oristano"}, 
               { value: "PD", text: "PD	Padova"}, { value: "PA", text: "PA Palermo"}, {value: "PR", text: "PR Parma"}, 
               { value: "PV", text: "PV	Pavia"}, { value: "PG", text: "PG Perugia"}, {value: "PU", text: "PU Pesaro-Urbino"}, 
               { value: "PE", text: "PE Pescara"}, { value: "PC", text: "PC Piacenza "}, {value: "PI", text: "PI Pisa"}, 
               { value: "PT", text: "PT	Pistoia"}, { value: "PN", text: "PN	Pordenone"}, {value: "PZ", text: "PZ Potenza"}, 
               { value: "PO", text: "PO	Prato"}, { value: "RG", text: "RG Ragusa"}, {value: "RA", text: "RA	Ravenna"}, 
               { value: "RC", text: "RC	Reggio-Calabria"}, { value: "RE", text: "RE	Reggio-Emilia"}, {value: "RI", text: "RI Rieti"}, 
               { value: "RN", text: "RN	Rimini"}, { value: "Roma", text: "Roma Roma"}, {value: "RO", text: "RO	Rovigo"}, 
               { value: "SA", text: "SA	Salerno"}, { value: "SS", text: "SS	Sassari"}, {value: "SV", text: "SV Savona"}, 
               { value: "SI", text: "SI	Siena"}, { value: "SR", text: "SR Siracusa"}, {value: "SO", text: "SO Sondrio"}, 
               { value: "TA", text: "TA	Taranto"}, { value: "TE", text: "TE	Teramo"}, {value: "TR", text: "TR Terni"}, 
               { value: "TO", text: "TO	Torino"}, { value: "TP", text: "TP Trapani"}, {value: "TN", text: "TN Trento"}, 
               { value: "TV", text: "TV	Treviso "}, { value: "TS", text: "TS Trieste"}, {value: "UD", text: "UD	Udine"}, 
               { value: "VA", text: "VA	Varese"}, { value: "VE", text: "VE Venezia"}, {value: "VB", text: "VB	Verbania"}, 
               { value: "VC", text: "VC	Vercelli"}, { value: "VR", text: "VR Verona"}, {value: "VV", text: "VV Vibo-Valentia"}, 
               { value: "VI", text: "VI	Vicenza"}, { value: "VT", text: " VT	Viterbo"}
            ],
            sesso: null,
            stato: null,
            tipo: null,
            titolare_effettivo: false, 
            pep:false, 
            rappresentante_principale: false, 
            non_in_carica: false, 
            titolare_effettivodal: null,
            titolare_effettivo_al: null,
            
            // RESIDENZA
            indirizzo_residenza: null,
            comune_residenza: null,
            cap_residenza: null,
            provincia_residenza: null,
            stato_residenza: null,
            
            // IDENTIFICAZIONE
            tipo_identificazione: null,
            numero_documento: null,
            autorita_localita_rilascio: null,
            data: null,
            data_scadenza: null,
            tipo_documento: null,
            data_rilascio: null,
            dati_acquisiti: null,

            showCheckFile: false,
            showLoader: false,

            idCliente: null,
            idSoggetto: null,

            allSoggetti: [],
            soggetto: [],
        }
    },
    computed: {},

    methods: {
        checkData: function() {
            if (this.codice_fiscale == null /*|| this.soggetto_estero == null */ || this.cognome == null || this.nome == null || this.data_nascita == null 
                || this.comune_nascita == null || this.provincia == null || this.sesso == null || this.stato == null || this.tipo == null 
                // || this.titolare_effettivo == null || this.pep == null || this.rappresentante_principale == null || this.non_in_carica == null 
                || this.indirizzo_residenza== null || this.comune_residenza == null || this.cap_residenza == null || this.provincia_residenza == null 
                || this.stato_residenza == null
                /*|| this.tipo_identificazione == null || this.numero_documento == null || this.autorita_localita_rilascio == null 
                || this.data == null || this.data_scadenza == null || this.tipo_documento == null || this.data_rilascio == null || this.dati_acquisiti == null*/
                ) {
                    return false;
                } else {
                    return true;
                }
        },

        checkFileUpload: function() {
            this.showCheckFile = true;
        },

        handleFileUpload: async function(){
            this.showLoader = true;
            let token = localStorage.getItem('access_token');
            let risposta;
            let errore = 0;
            this.file = this.$refs.file.files[0];
            let formData = new FormData()
            formData.append('documento', this.file)
            await AntiriciclaggioServices.caricaDocumentoSoggetto(this.idCliente, this.idSoggetto, formData)
            .then(response => { risposta = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                console.log(`errore 401`);
                let value = await Services.refreshTokenFunction();
                if (value) { await this.handleFileUpload(); }
            }
            this.showCheckFile = false;
            this.showLoader = false;
            // await this.getFileCaricati();
        },

        salvaValoriDati: async function() {
            if (this.checkData()) {
                let errore = 0;
                let dati = [];
                dati.push({ 
                    SOGGETTO_ESTERO: this.soggetto_estero, CF: this.codice_fiscale, COGNOME: this.cognome, NOME: this.nome, DATA_NASCITA: this.data_nascita, COMUNE_NASCITA: this.comune_nascita, 
                    PROVINCIA_NASCITA: this.provincia, SESSO: this.sesso, STATO_NASCITA: this.stato, TIPO: this.tipo, INDIRIZZO_RESIDENZA: this.indirizzo_residenza, 
                    COMUNE_RESIDENZA: this.comune_residenza, CAP_RESIDENZA: this.cap_residenza, PROVINCIA_RESIDENZA: this.provincia_residenza, STATO_RESIDENZA: this.stato_residenza,
                    /*IDENTIFICAZIONE_TIPO: this.tipo_identificazione, IDENTIFICAZIONE_NUMERO_DOCUMENTO: this.numero_documento, IDENTIFICAZIONE_AUTORITA: this.autorita_localita_rilascio, 
                    IDENTIFICAZIONE_DATA: this.data, IDENTIFICAZIONE_DATA_SCADENZA: this.data_scadenza, IDENTIFICAZIONE_TIPO_DOCUMENTO: this.tipo_documento, IDENTIFICAZIONE_DATA_RILASCIO: 
                    this.data_rilascio, MODALITA_ACQUISIZIONE_DATI: this.dati_acquisiti,*/
                    TITOLARE_EFFETTIVO: this.titolare_effettivo, PEP: this.pep, RAPPRESENTANTE_PRINCIPALE: this.rappresentante_principale, NON_IN_CARICA: this.non_in_carica
                });
                let datiJSON=JSON.stringify(dati[0]);
                console.log(`dati inviati`);
                console.log(datiJSON);
                let salvaValori = [];
                await AntiriciclaggioServices.createSoggetto(datiJSON, this.idCliente) 
                .then(response => { salvaValori= response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                    errore = error.response.status;
                    }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriDati(); }
                }
                this.idSoggetto = salvaValori.ID;
                let path = 'uploadfile-soggetto?idCliente=' + this.idCliente + '&idSoggetto=' + this.idSoggetto;
                this.$router.push({
                    path: path
                }) 
            } else {
                alert("Compilare tutti i dati!");
            }
        },

        main: async function() {
            this.idCliente = this.$route.query.idCliente;   
        },
    },
    
    mounted() {
        this.main();
    } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }
</style>
